var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "41px",
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Video") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.795712426
  }, /*#__PURE__*/React.createElement("g", {
    id: "Individual-Entry-Media-Field/Desktop",
    transform: "translate(-276.000000, -1163.000000)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(103.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.183282,979.366563 L213.82918,1012.65836 C214.570147,1014.14029 213.969474,1015.94231 212.487539,1016.68328 C212.070973,1016.89156 211.611633,1017 211.145898,1017 L177.854102,1017 C176.197248,1017 174.854102,1015.65685 174.854102,1014 C174.854102,1013.53426 174.962537,1013.07493 175.17082,1012.65836 L191.816718,979.366563 C192.557686,977.884628 194.359705,977.283955 195.841641,978.024922 C196.422223,978.315213 196.89299,978.785981 197.183282,979.366563 Z",
    id: "Icon/Video",
    transform: "translate(194.500000, 995.500000) rotate(90.000000) translate(-194.500000, -995.500000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/VideoPlay.91c5597978eff6760b404bcb99286abd.svg";
export { ForwardRef as ReactComponent };